import { Component, ViewEncapsulation, HostBinding, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { NavigationExtras, RouterLink as RouterLink_1 } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { NgIf } from '@angular/common';

interface RouterLink {
	icon: string;
	routerLink(params: ICellRendererParams<unknown, unknown>): LinkConfig | undefined;
}

interface LinkConfig {
	commands: unknown[];
	extras?: NavigationExtras;
}

@Component({
	selector: 'copo-icon-link-cell',
	templateUrl: './icon-link-cell.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgIf, RouterLink_1, MatIconModule]
})
export class IconLinkCellComponent implements ICellRendererAngularComp {
	@HostBinding('class.passthrough') readonly passthrough = true;

	linkConfig: LinkConfig | undefined;
	icon?: string;

	constructor(readonly changeDetectorRef: ChangeDetectorRef) {}

	agInit(params: ICellRendererParams<unknown, unknown>) {
		if (!params.colDef) {
			return;
		}
		const routerLink = <RouterLink> params.colDef.cellRendererParams;
		this.icon = routerLink.icon;
		this.linkConfig = routerLink.routerLink(params);
		this.changeDetectorRef.markForCheck();
	}

	refresh(params: ICellRendererParams<unknown, unknown>) {
		if (!params.colDef) {
			return false;
		}
		const routerLink = <RouterLink> params.colDef.cellRendererParams;
		this.icon = routerLink.icon;
		this.linkConfig = routerLink.routerLink(params);
		this.changeDetectorRef.markForCheck();
		return true;
	}
}
